import React from 'react'
import { Helmet } from 'react-helmet'

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keyword' content={keywords} />
    </Helmet>
  )
}

Meta.defaultProps = {
  title: 'Retail Center',
  description: 'We sell the best products at affordable price',
  keywords: 'electronics, buy electronics, grocery,buy grocery,buy clothes',
}

export default Meta
